'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CircuitBreakerError = exports.RetryError = exports.ExpectedPubNubError = undefined;

var _createPubNubError = require('./createPubNubError');

var _createPubNubError2 = _interopRequireDefault(_createPubNubError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExpectedPubNubError = exports.ExpectedPubNubError = (0, _createPubNubError2.default)({
  name: 'ExpectedPubNubError',
  defaultMessage: 'Expected PubNub Error'
});

var RetryError = exports.RetryError = (0, _createPubNubError2.default)({
  name: 'RetryError',
  defaultMessage: 'Retry Limit Exceeded'
});

var CircuitBreakerError = exports.CircuitBreakerError = (0, _createPubNubError2.default)({
  name: 'CircuitBreakerError',
  defaultMessage: 'Call Limit Exceeded'
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/PubNubJS/static-1.19/js/errors/index.js
// module id = 126
// module chunks = 0